import { SchoolClassVisibilities } from "../enums/schoolClasses";

export const isPrivateSchoolClass = (classVisibility?: SchoolClassVisibilities): boolean =>
    classVisibility === SchoolClassVisibilities.PRIVATE;

/**
 * Finds the next available class name by appending (1), (2), etc.
 *
 * Uses a while loop to fill gaps in the numbering sequence.
 * e.g. if "My class", "My class (1)", and "My class (3)" exist, it returns "My class (2)" — not (4).
 */
export const getUniqueDefaultClassName = (baseName: string, existingNames: string[]): string => {
    const lowerNames = existingNames.map((n) => n.toLowerCase());

    if (!lowerNames.includes(baseName.toLowerCase())) {
        return baseName;
    }

    let counter = 1;
    while (lowerNames.includes(`${baseName} (${counter})`.toLowerCase())) {
        counter++;
    }

    return `${baseName} (${counter})`;
};

/**
 * Returns true if the name contains emojis.
 */
export const containsUnsupportedCharacters = (name: string): boolean => {
    if (!name.trim()) return false;
    return new RegExp("\\p{Emoji_Presentation}|\\p{Emoji}\\uFE0F", "u").test(name);
};

interface IsDuplicateClassNameParams {
    name: string;
    existingNames: string[];
    excludeName?: string;
}

export const isDuplicateClassName = (params: IsDuplicateClassNameParams): boolean => {
    const trimmedName = params.name.trim();
    if (!trimmedName) return false;

    return params.existingNames
        .filter((existingName) => existingName.toLowerCase() !== params.excludeName?.toLowerCase())
        .some((existingName) => existingName.toLowerCase() === trimmedName.toLowerCase());
};

export type ClassNameError = "unsupported" | "duplicate" | null;

export const validateClassName = (name: string, existingNames: string[]): ClassNameError => {
    if (containsUnsupportedCharacters(name)) return "unsupported";
    if (isDuplicateClassName({ name, existingNames })) return "duplicate";
    return null;
};
